export default ($) => {
  var hmcformId = 28;

  setStep(hmcformId,1);
  $( '#fmpht_form' ).hide();
  $('#fmpht_btn').show();
  $( document ).ready(function () {
    $( '#fmpht_btn a' ).on( 'click', function( event ) {
      event.preventDefault();
      $( '#fmpht_form' ).show();
      $( '#fmpht_btn' ).hide();
      let page = $('#gform_page_' + hmcformId + '_' + 1);
      // disable or enable button
      if (page.find('.gform_page_fields input:checked').length > 0) {
        page.find('.formNext').prop('disabled', false);
      } else {
        page.find('.formNext').prop('disabled', true);
      }
    });
  });
  $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
    if (formId = hmcformId) {
      setStep(formId, currentPage);
    }
  } );

  function setStep(formId, currentPage){
    /*tippy('.salt-system-info', {
      content: `
        <div id="popover-pop" data-template="true">
          <div class="popover-container">
            <span class="close-thik desktop-dealer-panel__close"><i class="fa-solid fa-xmark"></i></span>
            <div class="popover-bottom text-left">
              <div class="row">
                <div class="col">
                <p class="small">A salt water system automatically generates chlorine from salt for soft, natural-feeling water so you’ll spend less time measuring and adding chemicals.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      `,
      placement: 'bottom',
      allowHTML: true,
      arrow: false,
      maxWidth: '395px',
      animation: 'fade',
      duration: [250, 100],
      delay: 150,
      interactive: true,
      appendTo: document.body,
      theme: 'light',
      trigger: 'mouseenter click', // 'click', 'manual'
      hideOnClick: true,
      onShown(instance) {
        jQuery(instance.popper).find('.close-thik').click(function(){
          instance.hide(0);
        });
      },
    });*/

    let page = $('#gform_page_' + formId + '_' + currentPage);
    page.find('input[type="radio"]').addClass('form-check-input');
    page.find('input[type="checkbox"]').addClass('form-check-input');
    // disable or enable button
    page.find('.gform_page_fields input').change(function () {
      if (page.find('.gform_page_fields input:checked').length > 0) {
        page.find('.formNext').prop('disabled', false);
      } else {
        page.find('.formNext').prop('disabled', true);
      }
    });
    let $page_steps = $('#gf_page_steps_'+formId);
    if (currentPage == 6) {
      let input_6 = document.querySelector('input[name="input_6"]:checked').value;
      let input_17 = document.querySelector('input[name="input_17"]:checked').value;
      $('#input_' + hmcformId + '_18 li').hide();
      $('#input_' + hmcformId + '_18 li input[type="radio"]:checked').each(function(){
        $(this).removeAttr('checked');
      });
      if ( (input_6 == 'Yes' && input_17 == 'All upright seating to maximize space') || (input_6 == 'No' && input_17 == 'All upright seating to maximize space') ){
        if (input_6 == 'Yes' && input_17 == 'All upright seating to maximize space') {
          $('.gchoice_' + hmcformId + '_18_3').show();
          $('.gchoice_' + hmcformId + '_18_4').show();
        } else {
          $('.gchoice_' + hmcformId + '_18_5').show();
          $('.gchoice_' + hmcformId + '_18_6').show();
        }
      } else {
        $('.gchoice_' + hmcformId + '_18_0').show();
        $('.gchoice_' + hmcformId + '_18_1').show();
        $('.gchoice_' + hmcformId + '_18_2').show();
      }
    }
    var lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    switch( lang ) {
      case 'fr-ca':
        $page_steps.before('<div class="gf_page_steps_info">Question ' + currentPage + ' sur 6</div>');
        break;
      case 'es-us':
        $page_steps.before('<div class="gf_page_steps_info">Pregunta ' + currentPage + ' de 6</div>');
        break;
      default:
        $page_steps.before('<div class="gf_page_steps_info">Question ' + currentPage + ' of 6</div>');
    }
    // Get buttons names
    var $next = page.find('.gform_next_button').val();
    var $prev = page.find('.gform_previous_button').val();
    var $submit = page.find('#gform_submit_button_'+formId).val();
    // add fake buttuns
    if ( currentPage != 6){
      $('.gform_page_footer.top_label').addClass('hide-it').after('<div class="gform_page_footer top_label formNext'+currentPage+'"><button id="formPrev" class="formPrev"><i class="fa-solid fa-chevron-left"></i> ' + $prev + '</button><button id="formNext" class="formNext">' + $next + ' <i class="fa-solid fa-chevron-right"></i></button></div>');
    } else {
      $('.gform_page_footer.top_label').addClass('hide-it').after('<div class="gform_page_footer top_label formNext'+currentPage+'"><button id="formPrev" class="formPrev"><i class="fa-solid fa-chevron-left"></i> ' + $prev + '</button><button id="formNext" class="formNext">' + $submit + ' <i class="fa-solid fa-chevron-right"></i></button></div>');
    }
    if(page.find('.gform_page_fields input:checked').length > 0){
      page.find('.formNext').prop('disabled', false);
    } else {
      page.find('.formNext').prop('disabled', true);
    }
    //prev
    $( '.formNext'+currentPage+' #formPrev' ).on( 'click', function( event ) {
      event.preventDefault();
      $( '.gform_page_footer .formPrev' ).append( ' <i class="fa-solid fa-loader fa-spin"></i>' );
      page.find('.gform_previous_button').click();
    });
    //next
    $( '.formNext'+currentPage+' #formNext' ).on( 'click', function( event ) {
      event.preventDefault();
      $( '.gform_page_footer .formNext' ).prepend( '<i class="fa-solid fa-loader fa-spin"></i> ' );
      page.find('.gform_next_button').click();
      page.find('#gform_submit_button_'+formId).click();
    });
  }
}